import { shallowEqual } from 'react-redux';

import { NsCard } from 'components/common/ns-card/NsCard';
import { NsContent } from 'components/common/ns-content/NsContent';
import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';

import { useAppSelector } from 'hooks/useAppSelector';
import { useNavigation } from 'hooks/useNavigation';
import { useMaskPII } from 'hooks/useMaskPII';

import { selectedAddress } from 'state/selected-address/selected-address-slice';

export const PersonalInformationSummarySupplyAddress = () => {
  const { mask } = useMaskPII();
  const address = useAppSelector(selectedAddress, shallowEqual);

  const { eventTypes, next } = useNavigation();

  const changeAddress = () => {
    next({ eventType: eventTypes.CHANGE_ADDRESS, wasVisited: true });
  };

  return (
    <>
      <NsContent spacing="normal">
        <h2 className="h4">Your supply address</h2>
      </NsContent>
      <NsCard>
        <NsDescriptionList>
          {[
            {
              term: 'Address',
              description: [
                <>
                  <span {...mask}>
                    {address?.displayName}, {address?.postcode}
                  </span>
                </>,
                <>
                  <NsSecondaryCta onClick={changeAddress} icon="">
                    Edit address
                  </NsSecondaryCta>
                </>
              ]
            }
          ]}
        </NsDescriptionList>
      </NsCard>
    </>
  );
};

export default PersonalInformationSummarySupplyAddress;
